import { GetterTree } from "vuex";
import { IApplicationState, ICardDetails } from "./types";
import { IRootState } from "@/store/types";
import {
  EDITABLE_STATUSES,
  MY_APPLICATION_ROLE_STATUSES
} from "@/constants/applicationStatuses";
import store from "@/store";
import { CREDIT, TELNET, CUSTOMER_MANAGER, SUPPORT } from "@/constants/roles";

const EDITABLE_ROLES = [CREDIT, TELNET, CUSTOMER_MANAGER, SUPPORT];

export namespace APPLICATION_GETTERS {
  export const IS_EDITABLE = "isEditable";
  export const GET_CARD_DETAILS = "getCards";
  export const GET_MY_APPLICATIONS_STATUSES = "getMyApplicationsStatuses";
}

export const getters: GetterTree<IApplicationState, IRootState> = {
  [APPLICATION_GETTERS.IS_EDITABLE](state: IApplicationState): boolean {
    const roles = store.state.auth.roles;
    const applicationData = state.applicationData;

    let editableStatus = false;

    if (applicationData) {
      editableStatus = EDITABLE_STATUSES.includes(applicationData.status);
    }

    let editableRole = false;
    if (roles && roles.length > 0) {
      editableRole = roles.some(role =>
        EDITABLE_ROLES.some(editable => editable === role)
      );
    }
    return editableStatus && editableRole;
  },
  [APPLICATION_GETTERS.GET_CARD_DETAILS](
    state: IApplicationState
  ): ICardDetails {
    const defaultCardDetails = {
      activeCardIndex: 0,
      cards: [
        {
          cardType: "Any",
          disabled: false,
          driver: {
            name: ""
          },
          fuelTypes: undefined,
          limits: {
            daily: 250,
            monthly: undefined
          },
          products: "AllExcludingTobacco",
          vehicle: {
            make: "",
            model: "",
            registration: ""
          }
        }
      ],
      deliveryAddress: {
        dpid: "",
        fullAddress: "",
        sourceDesc: ""
      },
      deliveryAddressText: "",
      hasManualDeliveryAddress: false,
      ifcsAccountNumber: undefined
    } as ICardDetails;

    const cardDetails =
      state.applicationData && state.applicationData.cardDetails;

    return cardDetails && cardDetails.cards ? cardDetails : defaultCardDetails;
  },
  [APPLICATION_GETTERS.GET_MY_APPLICATIONS_STATUSES](): any[] {
    let applicationStatuses: any[] = [];
    const roles = store.state.auth.roles || [];
    roles.forEach(role => {
      applicationStatuses = applicationStatuses.concat(
        MY_APPLICATION_ROLE_STATUSES[role]
      );
    });
    // filter out duplicates or empty values
    return applicationStatuses.filter(
      (value, index, self) => value && self.indexOf(value) === index
    );
  }
};
